import { useTranslation } from "react-i18next"

function loadPosts(locale) {
  try {
    return require(`@/generated/blog-posts-${locale}.json`)
  } catch {
    return []
  }
}

export function useBlogPosts() {
  const { i18n } = useTranslation()
  const locale = i18n.language?.startsWith("hu") ? "hu" : "ro"
  return loadPosts(locale)
}

export function useBlogPost(slug) {
  const posts = useBlogPosts()
  return posts.find((p) => p.slug === slug) || null
}
